import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Grid,
  styled,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  OutlinedInput,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  Table,
  TableBody,
  Paper,
  Tooltip,
  IconButton,
} from "@mui/material";
import CustomAutoComplete from "../CommonComponents/CustomAutoComplete";
import MultiSelectField from "../CommonComponents/MultiSelectField";
import CustomButton from "../CommonComponents/Button";
import { CompanyAndUsersData } from "../../actions/CompanyAndUsers";
import { UserIdApprover } from "../../actions/Approver";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import TopViewNav from "../CommonComponents/TopViewNav";

import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { companyWiseEmp } from "../../actions/Companywiseclient";
import CompnayModal from "../CompanyPermission/CompnayModal";
import CompanyUpdateModal from "../CompanyPermission/CompanyUpdateModal";
import viewHistoryIcon from "../../img/viewEventHistoryIcon.svg";
import viewEditIcon from "../../img/viewEventEditIcon.svg";
import ViewTrailDialog from "./ViewTrailDialog";

const TopHeading = styled(Typography)({
  fontSize: "25px",
  fontWeight: "bold",
  color: "#2A3478",
  marginTop: "20px",
  marginBottom: "20px",
});

let selectedArray = [];

const names = [
  "Oliver Hansen",
  "Van Henry",
  "April Tucker",
  "Ralph Hubbard",
  "Omar Alexander",
  "Carlos Abbott",
  "Miriam Wagner",
  "Bradley Wilkerson",
  "Virginia Andrews",
  "Kelly Snyder",
];

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
const ApproverCompanyPermissionModule = ({
  oldusr = [],
  companyId = [],
  siteId,
  companyUseId = [],
  approveUserId,
  openModal = false,
  approverlist = [],
  companyUsers = [],
  oldUsers = [],
  siteList = [],
  isRestrictedToEndUser = false,
  duplicateUsers = [],
  isLoading = false,
  setIsRestrictedToEndUser = () => {},
  setCompanyId = () => {},
  setCompanyUsers = () => {},
  setOldUsers = () => {},
  setSiteList = () => {},
  setSiteId = () => {},
  setOpenModal = () => {},
  setApproverlist = () => {},
  fetchMultiLevelApproverListForCompanyDetails = () => {},
  companyUserListHandle = () => {},
  approveUserHandle = () => {},
  siteListHandle = () => {},
  setIsLoading = () => {},
}) => {
  //   const [personName, setPersonName] = React.useState([]);
  //   const handleChange = (event) => {
  //     const {
  //       target: { value },
  //     } = event;
  //     setPersonName(typeof value === "string" ? value.split(",") : value);
  //   };
  const [companyData, setCompanyData] = useState();
  const [isEditable, setIsEditable] = useState(false);

  const [companyUsersCopy, setCompanyUsersCopy] = useState([]);
  const [ParmissonList, setPremissionList] = useState([]);
  const [openModalUpdate, setOpenModalUpdate] = useState(false);
  const [selectedApprover, setSelectedApprover] = useState([]);

  const [updateData, setUpdateData] = useState([]);
  const [userId, setUserId] = useState({});
  const [companyUpdateId, setCompanyUpadteId] = useState({});
  const [AprroverUpdateId, setAprroverUpdateId] = useState();
  const [rowData, setRowData] = useState({});
  const navigate = useNavigate();
  const [openTrail, setOpenTrail] = useState(false);
  const [selectedTrail, setSelectedTrail] = useState([]);
  const [minimalData, setMinimalData] = useState(null);

  console.log(selectedApprover, "companyIddfff");

  const handleOpenTrail = (trailVal, minimalData) => {
    setSelectedTrail(trailVal || []);
    setMinimalData(minimalData);
    setOpenTrail(true);
  };

  const handleCloseTrail = () => {
    setSelectedTrail();
    setMinimalData(null);
    setOpenTrail(false);
  };

  const fetchCompanyList = async () => {
    const res = await CompanyAndUsersData.fetchCompanyAndUserList();
    if (res !== null) {
      setCompanyData(res.data);
    } else {
      setCompanyData([]);
    }
  };

  //   let companyUseId = []
  const companyListHandle = (value) => {
    oldusr = [];
    if (value !== null) {
      setCompanyId(value);
      setCompanyUsers(value.userDtoList);
      setOldUsers([]);
    } else {
      setCompanyUsers([]);
      setCompanyId("");
    }
  };
  //   debugger

  const fetchCompanyWiseSiteList = async () => {
    const data = {
      companyId: companyId ? companyId.id : null,
      hrmsToken: JSON.parse(localStorage.getItem("data")).hrmsToken,
    };
    const res = await companyWiseEmp.getAllCompanyWiseSite(data);
    if (res !== null) {
      console.log(res);
      setSiteList(res.data);
    } else {
      setSiteList([]);
    }
  };

  //   console.log(companyUseId);

  const fetchUserApprover = async () => {
    //alert(companyId)
    if (companyId == undefined || companyId == "") {
      alert("plz Select company Name ");
      return false;
    } else if (companyId?.isSiteConfigEnabled && !siteId?.id) {
      alert("plz Select Site ");
      return false;
    } else if (companyUseId == "") {
      alert("plz Select CompanyUser Name ");
      return false;
    } else if (approveUserId == null) {
      alert("plz Select approver Name ");
      return false;
    }
    let ids = JSON.parse(localStorage.getItem("data")).id;
    let hrmsCompanyId = JSON.parse(localStorage.getItem("data")).hrmsCompanyId;

    setIsLoading(true);
    const payload = {
      hrmsCompanyId: companyId ? companyId.id : null,
      createdBy: ids,
      userIds: companyUseId,
      approverId: approveUserId,
      companyName: companyId ? companyId.companyName : null,
    };
    const res = await UserIdApprover.fetchApprover(payload);
    if (res !== null && res?.status === 200) {
      // console.log("somya res: ", res);
      // setCompanyData(res.data);
      setCompanyData(res?.data?.data);

      alert("Permission is approved!!!");
      localStorage.setItem("holdApproverAtOdRestoreEmployee", true);
      setIsLoading(false);
      window.location.reload(true);
      //navigate("/dashboard");
      setOpenModal(false);
    } else {
      // console.log("somya res: ", res);
      const parsedErrMessage =
        res?.response?.data?.responseDescription ||
        res?.message ||
        "Something Went Wrong";
      alert(parsedErrMessage);
      setIsLoading(false);
      // setCompanyData([]);
      // window.location.reload(true);
    }

    // setOpenModal(false);
  };
  const fetchApproverList = async () => {
    let hrmsCompanyId = JSON.parse(localStorage.getItem("data")).hrmsCompanyId;
    let data = {
      hrmsCompanyId: companyId ? companyId.id : null,
      userIds: companyUseId,
      approverId: approveUserId,
    };

    const res = await UserIdApprover.fetchApproverList(data);
    if (res !== null) {
      console.log(res);
      setApproverlist(res.data);
    } else {
      setApproverlist([]);
    }
  };

  const updateuserHandler = (data) => {
    console.log(data, "dwdwedetf");
    const approverDataByCompanyID = companyData?.filter((ele) => {
      return data.hrmsCompanyId == ele.id;
    });
    // let array =
    //   (Array.isArray(approverDataByCompanyID) &&
    //     approverDataByCompanyID[0]?.userDtoList) ||
    //   [];

    let array = [];

    if (
      Array.isArray(approverDataByCompanyID) &&
      approverDataByCompanyID.length > 0
    ) {
      const item = approverDataByCompanyID[0];
      const list = item?.userDtoList || [];

      if (item?.isSiteConfigEnabled) {
        array = list.filter((u) => u?.siteId === data?.user?.siteId);
      } else {
        array = list;
      }
    }

    console.log(approverDataByCompanyID, "approverDataByCompanyID");

    const uniqueOnject =
      array &&
      array.filter(
        ({ id: id1 }) => ![data.user].some(({ id: id2 }) => id1 === id2),
      );
    console.log(uniqueOnject, "uniqueOnjectedge");
    console.log(data, approverDataByCompanyID, "dgdd");
    setSelectedApprover(uniqueOnject);
    setUserId(data.user.name);
    setCompanyUpadteId(data.createdByUser.companyName);
    setUserId(data.user.name + `(${data.user.empCode})`);
    setUpdateData(data);
    setOpenModalUpdate(true);
    setIsRestrictedToEndUser(true);
  };

  const updateUserHandler = () => {
    if (AprroverUpdateId == undefined || AprroverUpdateId == "") {
      alert("plz Select Aprrover Name ");
      return false;
    }
    const data = {
      id: updateData.id,
      updatedApproverId: AprroverUpdateId ? AprroverUpdateId.id : null,
    };
    setIsLoading(true);
    UserIdApprover.deletArroved(data).then((res) => {
      if (res !== null && res?.status === 200) {
        // fetchApproverList();
        fetchMultiLevelApproverListForCompanyDetails();
        alert("Approver  Update Successfully");
        setOpenModalUpdate(false);
        setIsRestrictedToEndUser(false);
        localStorage.setItem("holdApproverAtOdRestoreEmployee", true);
        setIsLoading(false);
        window.location.reload(true);
      } else {
        // console.log("somya res: ", res);
        const parsedErrMessage =
          res?.response?.data?.responseDescription ||
          res?.message ||
          "Something Went Wrong";
        alert(parsedErrMessage);
        setIsLoading(false);
      }
    });
    // setOpenModalUpdate(false);
  };
  const deleteHandler = () => {
    const data = {
      id: updateData.id,
      userId: updateData?.user?.id || null,
      // updatedApproverId:AprroverUpdateId?AprroverUpdateId.id:null,
    };
    UserIdApprover.deletArroved(data).then((res) => {
      if (res !== null && res?.status === 200) {
        // fetchApproverList();
        fetchMultiLevelApproverListForCompanyDetails();
        alert("Approver Delete Successfully");
        setOpenModalUpdate(false);
        setIsRestrictedToEndUser(false);
        localStorage.setItem("holdApproverAtOdRestoreEmployee", true);
        window.location.reload(true);
      } else {
        // console.log("somya res: ", res);
        const parsedErrMessage =
          res?.response?.data?.responseDescription ||
          res?.message ||
          "Something Went Wrong";
        alert(parsedErrMessage);
      }
    });
    // setOpenModalUpdate(false);
  };

  const topViewNavData = React.useMemo(
    () => ({
      title: "Company Permission",
      backPath: "Company/Emp wise Configuration",
      backPathRoute: "/companywiseclient",
    }),
    [],
  );

  useEffect(() => {
    fetchCompanyList();
    // fetchApproverList();
    fetchMultiLevelApproverListForCompanyDetails();
  }, []);

  //   useEffect(() => {
  //     if (companyId?.id) {
  //       fetchCompanyWiseSiteList();
  //     } else {
  //       setSiteList([]);
  //     }
  //     setSiteId(null);
  //   }, [companyId]);

  return (
    <React.Fragment>
      <ViewTrailDialog
        openTrail={openTrail}
        handleCloseTrail={handleCloseTrail}
        selectedTrail={selectedTrail || []}
        minimalData={minimalData}
      />

      <CompnayModal
        title="Add Company Permisson"
        companyData={companyData}
        companyListHandle={companyListHandle}
        companyUsers={companyUsers}
        companyUserListHandle={companyUserListHandle}
        oldUsers={oldUsers}
        approveUserHandle={approveUserHandle}
        openModal={openModal}
        setOpenModal={setOpenModal}
        fetchUserApprover={fetchUserApprover}
        companyId={companyId}
        userId={userId}
        companyUseId={companyUseId}
        siteId={siteId}
        siteList={siteList}
        siteListHandle={siteListHandle}
        isRestrictedToEndUser={isRestrictedToEndUser}
        setIsRestrictedToEndUser={setIsRestrictedToEndUser}
        duplicateUsers={duplicateUsers}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
      />

      <CompanyUpdateModal
        title="Update Company Permisson"
        companyData={companyData}
        companyListHandle={companyListHandle}
        companyUsers={companyUsers}
        companyUserListHandle={companyUserListHandle}
        updateData={updateData}
        oldUsers={oldUsers}
        approveUserHandle={approveUserHandle}
        openModal={openModalUpdate}
        setOpenModal={setOpenModalUpdate}
        fetchUserApprover={fetchUserApprover}
        companyUpdateId={companyUpdateId}
        setCompanyUpadteId={setCompanyUpadteId}
        userId={userId}
        AprroverUpdateId={AprroverUpdateId}
        setAprroverUpdateId={setAprroverUpdateId}
        setUserId={setUserId}
        selectedApprover={selectedApprover}
        setSelectedApprover={setSelectedApprover}
        updateUserHandler={updateUserHandler}
        deleteHandler={deleteHandler}
        companyId={companyId}
        siteId={siteId}
        siteList={siteList}
        siteListHandle={siteListHandle}
        isRestrictedToEndUser={isRestrictedToEndUser}
        setIsRestrictedToEndUser={setIsRestrictedToEndUser}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
      />
      <TableContainer
        component={Paper}
        sx={{
          height: "calc(100vh - 217px)",
          "&::-webkit-scrollbar": {
            width: "0px",
          },
        }}
      >
        <Table size="small" aria-label="a dense table">
          <TableHead style={{ color: "#fff", backgroundColor: "#32577e" }}>
            <TableCell className="tabalecellStyle" align="center">
              S.No
            </TableCell>
            {/* <TableCell className="tabalecellStyle" align="center">
              Created By
            </TableCell> */}
            {/* <TableCell className="tabalecellStyle" align="center">
              Company Name
            </TableCell> */}
            <TableCell className="tabalecellStyle" align="center">
              User Name
            </TableCell>
            <TableCell className="tabalecellStyle" align="center">
              Approver Name
            </TableCell>
            <TableCell className="tabalecellStyle" align="center">
              Actions
            </TableCell>
          </TableHead>
          <TableBody>
            {approverlist &&
              approverlist.length > 0 &&
              approverlist.map((val, ind) => {
                console.log(val, "dkjfgeuyfueyrf");
                return (
                  <>
                    <TableRow>
                      <TableCell align="center">
                        {val.communicationId !== null ? `${ind + 1}` : ind + 1}
                      </TableCell>

                      {/* <TableCell
                        align="center"
                        style={{
                          minWidth: "160px",
                        }}
                      >
                        {val && val.createdByUser && val.createdByUser.name
                          ? val.createdByUser.name
                          : "NA"}
                        {`${
                          val.createdByUser.empCode
                            ? `(${val.createdByUser.empCode})`
                            : ""
                        }`}
                      </TableCell> */}
                      {/* <TableCell align="center">
                        {val && val.companyName ? val.companyName : "NA"}
                      </TableCell> */}
                      <TableCell align="center">
                        {val && val.user && val.user.name
                          ? val.user.name
                          : "NA"}
                        {`${val.user.empCode ? `(${val.user.empCode})` : ""}`}
                      </TableCell>
                      {Boolean(val?.isMultiLevelApproverEnabled) ? (
                        <>
                          <TableCell align="center">
                            <Box
                              component="span"
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              {val?.approverList?.length > 0 &&
                                (() => {
                                  const displayedApprovers =
                                    val.approverList.slice(0, 1);
                                  const remainingCount =
                                    val.approverList.length -
                                    displayedApprovers.length;

                                  return (
                                    <>
                                      {displayedApprovers.map(
                                        (approver, index) => (
                                          <span
                                            key={index}
                                            style={{ marginRight: "8px" }}
                                          >
                                            {approver?.approverId?.name}
                                            {approver?.approverId?.empCode
                                              ? ` (${approver?.approverId?.empCode})`
                                              : ""}
                                          </span>
                                        ),
                                      )}
                                      {remainingCount > 0 && (
                                        <Tooltip
                                          arrow
                                          title={val.approverList
                                            .slice(1)
                                            .map(
                                              (item) =>
                                                `${
                                                  item?.approverId?.name || "NA"
                                                } (${
                                                  item?.approverId?.empCode ||
                                                  ""
                                                })`,
                                            )
                                            .join(", ")}
                                          PopperProps={{
                                            modifiers: [
                                              {
                                                name: "offset",
                                                options: {
                                                  offset: [0, -6],
                                                },
                                              },
                                            ],
                                          }}
                                        >
                                          <span
                                            style={{
                                              cursor: "default",
                                              marginLeft: "8px",
                                              marginTop: "3px",
                                              background: "#cbcbcb",
                                              lineHeight: 1.7,
                                              borderRadius: "5px",
                                            }}
                                          >
                                            &nbsp; +{remainingCount} more &nbsp;
                                          </span>
                                        </Tooltip>
                                      )}
                                    </>
                                  );
                                })()}

                              {/* Edit Icon */}
                              {/* <EditIcon
                                sx={{
                                  color: "green",
                                  marginLeft: "10px",
                                  cursor: "pointer",
                                }}
                                onClick={() => updateuserHandler(val)}
                              /> */}
                            </Box>
                          </TableCell>
                        </>
                      ) : (
                        <TableCell align="center">
                          <span
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {val && val.approver && val.approver.name
                              ? val.approver.name
                              : "NA"}
                            {`${
                              val.approver.empCode
                                ? `(${val.approver.empCode})`
                                : ""
                            }`}
                            {/* <EditIcon
                              sx={{
                                color: "green",
                                marginLeft: "10px",
                                cursor: "pointer",
                              }}
                              onClick={() => updateuserHandler(val)}
                            /> */}
                          </span>
                        </TableCell>
                      )}

                      <TableCell align="center">
                        <Box
                          component="span"
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Tooltip
                            title="Edit"
                            arrow
                            slotProps={{
                              popper: {
                                modifiers: [
                                  {
                                    name: "offset",
                                    options: {
                                      offset: [0, -10],
                                    },
                                  },
                                ],
                              },
                            }}
                          >
                            <IconButton onClick={() => updateuserHandler(val)}>
                              <img
                                src={viewEditIcon}
                                alt="EditIcon"
                                style={{
                                  width: "19px",
                                  height: "19px",
                                  cursor: "pointer",
                                }}
                              />
                            </IconButton>
                          </Tooltip>

                          <Tooltip
                            title="Trail"
                            arrow
                            slotProps={{
                              popper: {
                                modifiers: [
                                  {
                                    name: "offset",
                                    options: {
                                      offset: [0, -10],
                                    },
                                  },
                                ],
                              },
                            }}
                          >
                            <IconButton
                              onClick={() =>
                                handleOpenTrail(
                                  Boolean(val?.trails?.length > 0)
                                    ? val?.trails
                                    : [],
                                  {
                                    user: val?.user,
                                    isActive: val?.isActive,
                                  },
                                )
                              }
                            >
                              <img
                                src={viewHistoryIcon}
                                alt="HistoryIcon"
                                style={{
                                  width: "19px",
                                  height: "19px",
                                  cursor: "pointer",
                                }}
                              />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  </>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
    </React.Fragment>
  );
};

export default ApproverCompanyPermissionModule;
